<template>
  <div class="business-status-selector">
    <div class="status-display" :class="statusClass" @click="toggleDropdown">
      <div class="status-indicator">
        <i :class="statusIcon"></i>
        <span class="status-text">{{ statusLabel }}</span>
      </div>
      <i class="icon-chevron-down" :class="{ 'rotated': isDropdownOpen }"></i>
    </div>

    <div v-if="isDropdownOpen" class="dropdown-menu">
      <div
        v-for="status in statusOptions"
        :key="status.value"
        class="dropdown-item"
        :class="{ 'active': status.value === currentStatus }"
        @click="selectStatus(status.value)"
      >
        <i :class="status.icon"></i>
        <span>{{ status.label }}</span>
      </div>
    </div>

    <div v-if="isDropdownOpen" class="dropdown-overlay" @click="closeDropdown"></div>
  </div>
</template>

<script>
import { SellerStatus } from '@/store/modules/settingSeller';

export default {
  name: 'BusinessStatusSelector',

  data() {
    return {
      isDropdownOpen: false,
      statusOptions: [
        {
          value: SellerStatus.WORKING,
          label: 'Trabalhando',
          icon: 'icon-check-circle',
          class: 'status-working'
        },
        {
          value: SellerStatus.CLOSED,
          label: 'Fechado',
          icon: 'icon-close-circle',
          class: 'status-closed'
        },
        {
          value: SellerStatus.BREAK,
          label: 'Pausa',
          icon: 'icon-pause-circle',
          class: 'status-break'
        },
        {
          value: SellerStatus.VACATION,
          label: 'Férias',
          icon: 'icon-calendar',
          class: 'status-vacation'
        }
      ]
    };
  },

  props: {
    currentStatus: {
      type: String,
      default: SellerStatus.WORKING
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    currentStatusOption() {
      return this.statusOptions.find(option => option.value === this.currentStatus) || this.statusOptions[0];
    },

    statusLabel() {
      return this.currentStatusOption.label;
    },

    statusIcon() {
      return this.currentStatusOption.icon;
    },

    statusClass() {
      return [
        'status-selector',
        this.currentStatusOption.class,
        { 'disabled': this.isLoading }
      ];
    }
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },

  methods: {
    toggleDropdown() {
      if (!this.isLoading) {
        this.isDropdownOpen = !this.isDropdownOpen;
      }
    },

    closeDropdown() {
      this.isDropdownOpen = false;
    },

    selectStatus(status) {
      if (status !== this.currentStatus && !this.isLoading) {
        this.$emit('statusChange', status);
      }
      this.closeDropdown();
    },

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.closeDropdown();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.business-status-selector {
  position: relative;

  .status-display {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    border-radius: 4px;
    cursor: pointer;
    min-width: 140px;
    transition: all 0.2s ease;

    &:hover:not(.disabled) {
      opacity: 0.8;
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    .status-indicator {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      i {
        font-size: 14px;
      }

      .status-text {
        font-size: 14px;
        font-weight: 500;
      }
    }

    .icon-chevron-down {
      font-size: 12px;
      transition: transform 0.2s ease;

      &.rotated {
        transform: rotate(180deg);
      }
    }

    &.status-working {
      background: #E8F5E8;
      color: #08B978;
      border: 1px solid #08B978;
    }

    &.status-closed {
      background: #FFE8E8;
      color: #FF5A5A;
      border: 1px solid #FF5A5A;
    }

    &.status-break {
      background: #FFF4E6;
      color: #FFA500;
      border: 1px solid #FFA500;
    }

    &.status-vacation {
      background: #E6F3FF;
      color: #006EFF;
      border: 1px solid #006EFF;
    }
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #DADADA;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    margin-top: 4px;

    .dropdown-item {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.75rem;
      cursor: pointer;
      transition: background-color 0.2s ease;

      &:hover {
        background: #F5F5F5;
      }

      &.active {
        background: #E8F5E8;
        color: #08B978;
      }

      i {
        font-size: 14px;
      }

      span {
        font-size: 14px;
      }
    }
  }

  .dropdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
  }
}
</style> 